import { GetFrontModules } from "services/page/app";
import { TModule } from "services/page/admin";
import { CommonRuntime, getMeta, Platform } from "utils/runtime";
import { transformBanner } from "./banner";
import { PrmParams } from "utils/prm";
import { TCombinedCDBannerModule, TCDBannerExtend } from "services/page/modules";
import { TBannerItem } from "views/services/banner";
import { CountdownBannerMod } from "views/mobile/components/MCountdownBanner";
import { TCountdownModule } from "views/services/playground";

/**
 * 取有效module的除@type之外的content
 */
export enum DTPlatform {
	PC = "pc",
	M = "mobile",
}
export const getModuleData = (mod: TModule): { [key: string]: any } => {
	const dataKeys = Object.keys(mod.module).filter((item) => item !== "@type");
	return dataKeys.reduce((result, item) => {
		return {
			...result,
			[item]: mod.module[item],
		};
	}, {});
};

export const getValidDataByPlatfrom = (
	mod: { [key: string]: any },
	platform?: DTPlatform,
): { [key: string]: any } => {
	return mod?.[platform] || mod;
};

/**
 * 刷新模块
 * @param moduleId
 * @param runtime
 * @returns
 */
interface RefreshModuleTransParam {
	runtime: CommonRuntime;
	prm: PrmParams;
}
export const refreshModule = async (
	moduleId: string,
	{ runtime }: Partial<RefreshModuleTransParam>,
): Promise<TModule> => {
	const meta = getMeta(runtime);
	try {
		const result = await GetFrontModules(
			{
				moduleId: [moduleId],
				meta,
			},
			{
				baseInfo: {
					catalog: runtime.countryCode3,
					platform: runtime.platform,
					isuat: runtime.isUat,
					onlyFetch: true,
				},
			},
		);
		if (result?.mods?.[moduleId]) {
			return result.mods?.[moduleId];
		}
	} catch (error) {
		throw new Error(error);
	}
	return null;
};

/**
 * 倒计时结束刷新模块
 * @param moduleId
 * @param runtime
 * @returns
 */
export const refreshCountDownModule =
	(moduleId: string, { runtime, prm }: RefreshModuleTransParam) =>
	async (): Promise<CountdownBannerMod> => {
		const module = await refreshModule(moduleId, { runtime });
		const countDownModule: TCombinedCDBannerModule = getModuleData(module);

		if (countDownModule) {
			let cBanner: TBannerItem;
			let cBannerBox: TCDBannerExtend;
			if (runtime.platform === Platform.WEB) {
				cBannerBox = countDownModule?.pc;
				cBanner = transformBanner(cBannerBox?.banner, runtime, prm);
			} else {
				cBannerBox = countDownModule?.mobile;
				cBanner = transformBanner(cBannerBox?.banner, runtime, prm);
			}
			return {
				banner: cBanner,
				timer: cBannerBox?.timer as TCountdownModule,
				actState: cBannerBox?.state,
			};
		}
		return null;
	};
